export const GeneratedProposalLocale = {
  en: {
    proposal_id: 'Proposal ID',
    proposal_name: 'Proposal Name',
    property_name: 'Property Name',
    created_at: 'Created At',
    template_type: 'Template Type',
    template_mode: 'Template Mode',
    share: 'Share',
    preview: 'Preview',
    generated_proposals: 'Generated Proposals',
    shared_success: 'Proposal has been shared successfully.',
    send_to_lead: 'Send to Lead',
    select_leads: 'Select Leads',
    select_users: 'Select Users',
    send_to_user: 'Send to User',
    shared_whatsapp_error:
      'The selected user does not have a valid WhatsApp number.',
    no_proposals:
      'No proposals found. Generate a proposal in the Proposal Builder.',
    share_error:
      'Please select at least one user or lead to share the proposal with.',
    shared_whatsapp_error_user:
      'The selected user does not have a valid WhatsApp number.',
    shared_whatsapp_error_lead:
      'The selected lead does not have a valid WhatsApp number.',
  },
  ar: {
    proposal_id: 'معرف العرض',
    proposal_name: 'اسم العرض',
    property_name: 'اسم العقار',
    created_at: 'تاريخ الإنشاء',
    template_type: 'نوع القالب',
    template_mode: 'وضع القالب',
    share: 'مشاركة',
    preview: 'معاينة',
    generated_proposals: 'العروض المُنشأة',
    shared_success: 'تمت مشاركة العرض بنجاح.',
    send_to_lead: 'إرسال إلى العميل المحتمل',
    select_leads: 'اختر العملاء المحتملين',
    select_users: 'اختر المستخدمين',
    send_to_user: 'إرسال إلى المستخدم',
    shared_whatsapp_error: 'المستخدم المحدد لا يملك رقم واتساب صالحًا.',
    no_proposals:
      'لم يتم العثور على أي مقترحات. قم بإنشاء مقترح في منشئ المقترحات.',
    share_error:
      'يرجى تحديد مستخدم أو عميل محتمل واحد على الأقل لمشاركة العرض معه.',
    shared_whatsapp_error_user: 'المستخدم المحدد لا يحتوي على رقم واتساب صالح.',
    shared_whatsapp_error_lead:
      'العميل المحتمل المحدد لا يحتوي على رقم واتساب صالح.',
  },
  cn: {
    proposal_id: '提案编号',
    proposal_name: '提案名称',
    property_name: '房产名称',
    created_at: '创建日期',
    template_type: '模板类型',
    template_mode: '模板模式',
    share: '分享',
    preview: '预览',
    generated_proposals: '生成的提案',
    shared_success: '提案已成功共享。',
    shared_whatsapp_error: '所选用户没有有效的 WhatsApp 号码',
    no_proposals:
      'Предложения не найдены. Создайте предложение в Конструкторе предложений.',
    share_error: '请至少选择一位用户或潜在客户以分享提案。',
    shared_whatsapp_error_user: '所选用户没有有效的 WhatsApp 号码。',
    shared_whatsapp_error_lead: '所选潜在客户没有有效的 WhatsApp 号码。',
  },
  ru: {
    proposal_id: 'ID предложения',
    proposal_name: 'Название предложения',
    property_name: 'Название недвижимости',
    created_at: 'Дата создания',
    template_type: 'Тип шаблона',
    template_mode: 'Режим шаблона',
    share: 'Поделиться',
    preview: 'Предпросмотр',
    generated_proposals: 'Сгенерированные предложения',
    shared_success: 'Предложение успешно отправлено.',
    shared_whatsapp_error:
      'У выбранного пользователя нет действительного номера WhatsApp.',
    no_proposals: '未找到提案。请在提案生成器中生成提案。',
    share_error:
      'Пожалуйста, выберите хотя бы одного пользователя или лида для отправки предложения.',
    shared_whatsapp_error_user:
      'У выбранного пользователя нет действительного номера WhatsApp.',
    shared_whatsapp_error_lead:
      'У выбранного лида нет действительного номера WhatsApp.',
  },
};

export const GeneratedProposalTranslationPath = 'GeneratedProposalsView';
